import React, { useRef, useEffect } from "react";
import domToImage from "dom-to-image";
import { useDispatch, useSelector } from "react-redux";
import { updateInvoice } from "../../actions/invoiceActions";
import moment from "moment";
import toyTrainLogo from "./billlogo/toy_train.png";
import maharanaPratapLogo from "./billlogo/maharana_pratap.png";
import boatLogo from "./billlogo/boat.png";


const InvoicePreview = ({ creditPayment, userProfile, invoice, isTaxCopy }) => {
  // Use roundoff from invoice data and clean any extra characters
  const roundoff = parseFloat(String(invoice?.roundoff || 0).trim()) || 0;


  return (
    <div
      id="a4-invoice-print"
      style={{
        width: "auto",
        padding: "20px 10px",
        lineHeight: "35px",
        backgroundColor: "white",
        border: "0px solid #FFFFFF",
      }}
    >
      <div
        style={{ textAlign: "center", fontSize: "30px", fontWeight: "bold" }}
      >
        {/* {isTaxCopy ? "Tax Copy" : "Customer Copy"} */}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "20px",
          gap: "20px",
          width: "100%",
        }}
      >
        <img
          src={maharanaPratapLogo}
          alt="Maharana Pratap Logo"
          style={{ height: "150px", width: "auto", objectFit: "contain" }}
        />
        <div style={{ flex: 1, textAlign: "center" }}>
          <div
            style={{
              fontSize: "32px",
              fontWeight: "800",
              textAlign: "center",
              color: "#000000",
              textShadow: "0.5px 0.5px 0.5px rgba(0,0,0,0.2)",
              letterSpacing: "0.5px",
              marginBottom: "5px",
            }}
          >
            {userProfile.businessName}
          </div>
          <div
            style={{
              fontSize: "26px",
              textAlign: "center",
              fontWeight: "600",
              color: "#000000",
              letterSpacing: "0.3px",
            }}
          >
            {userProfile.companyName}
          </div>

          <div
            style={{
              fontSize: "26px",
              textAlign: "center",
              fontWeight: "600",
              color: "#000000",
              letterSpacing: "0.3px",
            }}
          >
            {userProfile.companyDescription}
          </div>

        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <img
            src={toyTrainLogo}
            alt="Toy Train Logo"
            style={{ height: "100px", width: "auto", objectFit: "contain" }}
          />
          <img
            src={boatLogo}
            alt="Boat Logo"
            style={{ height: "100px", width: "auto", objectFit: "contain" }}
          />
        </div>
      </div>
      <div style={{ textAlign: "center", marginTop: "20px", fontSize: "28px" }}>
        CIN No. : {userProfile.cinNo}
        <br />
        GST No. : {userProfile.gstNo}
      </div>

      <div
        style={{
          fontSize: "22px",
          textAlign: "center",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "15px",
        }}
      >
        <span>PHONE: {userProfile.phoneNumber}</span>
      </div>

      <div
        style={{
          fontSize: "22px",
          textAlign: "center",
          width: "100%",
          marginTop: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "15px",
        }}
      >
        <span>EMAIL: s-c-i-L@hotmail.com</span>
      </div>

      {/* Trip and Seats Info */}
      <div
        style={{
          fontSize: "22px",
          textAlign: "center",
          width: "100%",
          marginTop: "10px",
          fontWeight: 700,
        }}
      >
        राउंड No. : {invoice?.tripNumber || "N/A"}
      </div>
      {invoice?.selectedSeats?.length > 0 && (
  <div style={{ marginBottom: 8, display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center" }}>
    {Object.entries(
      invoice.selectedSeats.reduce((acc, seat) => {
        const bogie = seat[0];
        const seatNum = Number(seat.slice(1));
        if (!acc[bogie]) acc[bogie] = [];
        acc[bogie].push(seatNum);
        return acc;
      }, {})
    ).map(([bogie, seats]) => (
      <div
        key={bogie}
        style={{
          fontSize: "22px",
          fontWeight: 700,
          padding: "8px 20px",
          borderRadius: "24px",
          background: "#f5f5f5",
          border: "2px solid #1976d2",
          color: "#1976d2",
          marginBottom: 4,
        }}
      >
        डिब्बा {bogie} : सीट :- {seats.sort((a, b) => a - b).join(", ")}
      </div>
    ))}
  </div>
)}

      <div
        style={{
          fontSize: "22px",
          textAlign: "center",
          width: "100%",
          marginTop: "10px",
          lineHeight: "1.5",
          fontWeight: "bold",
          color: "#000000",
        }}
      >
        <div style={{ fontWeight: "700" }}>
          स्टेशन: 1 ☐ समोर बाग से कमल तलाई तक
        </div>
        <div style={{ marginLeft: "40px", fontWeight: "700" }}>विराम</div>
        <div style={{ fontWeight: "700" }}>
          स्टेशन: 2 ☐ कमल तलाई से समोर बाग तक
        </div>
      </div>

      <div
        style={{
          width: "100%",
          borderBottom: "medium dotted #333333",
          height: "5px",
        }}
      ></div>
      <div
        style={{
          marginTop: "30px",
          fontSize: "4rem",
          textAlign: "center",
          fontWeight: "400px",
          width: "100%",
        }}
      >
        ₹{invoice.total.toFixed(2)}
      </div>
      <div
        style={{
          marginTop: "10px",
          fontSize: "18px",
          textAlign: "center",
          fontWeight: "bold",
          width: "100%",
        }}
      >
        Total
      </div>
      {invoice.isComplimentary && (
        <div
          style={{
            margin: "16px auto 0 auto",
            textAlign: "center",
            fontSize: "2rem",
            fontWeight: "bold",
            color: "#d32f2f",
            letterSpacing: "2px",
            border: "2px dashed #d32f2f",
            borderRadius: "8px",
            padding: "8px 0",
            background: "#fff0f0",
            width: "80%",
          }}
        >
          Complimentary Pass
        </div>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          fontSize: "28px",
          textAlign: "left",
          marginTop: "20px",
          width: "100%",
          borderTop: "medium dotted #333333",
          padding: "10px 0 10px 0",
        }}
      >
        <div style={{ flex: 1, textAlign: 'left', fontSize: '28px', fontWeight: 700 }}>
          Invoice No: 25-26 / {invoice.invoiceNumber}
        </div>
        <div style={{ flex: 1, textAlign: 'right' }}>
          <div style={{ fontSize: '28px', fontWeight: 700 }}>
            Bill To: {invoice?.client?.name ? invoice.client.name : "Guest"}
          </div>
          {invoice?.client?.gstNo && (
            <div style={{ fontSize: '22px', fontWeight: 700, marginTop: 2, }}>
              Customer GSTIN: {invoice.client.gstNo}
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          fontSize: "28px",
          textAlign: "left",
          paddingTop: "20px",
          width: "100%",
        }}
      >
        <span style={{ fontSize: "28px", width: "50%" }}>
          Date: {moment(invoice.createdAt).format("DD-MM-YYYY")}
        </span>
        <span
          style={{
            fontSize: "28px",
            float: "right",
            textAlign: "right",
            width: "50%",
          }}
        >
          Time: {moment(invoice.createdAt).format("hh:mm a")}
        </span>
      </div>
      <div
        style={{
          width: "100%",
          borderBottom: "medium dotted #333333",
          height: "5px",
        }}
      ></div>
      <div style={{ maxHeight: "200px", overflowY: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "24px",
          }}
        >
          <thead>
            <tr>
              <th style={{ width: "10%", fontSize: "28px" }}>S.No.</th>
              <th style={{ width: "65%", fontSize: "28px" }}>Items/SAC Code</th>
              <th
                style={{
                  width: "15%",
                  textAlign: "center",
                  fontSize: "28px",
                  right: "30%",
                }}
              >
                Qty
              </th>
              <th
                style={{ width: "30%", textAlign: "right", fontSize: "28px" }}
              >
                Amount
              </th>
            </tr>
          </thead>
        </table>

        <div
          style={{
            width: "100%",
            borderBottom: "medium dotted #333333",
            height: "5px",
          }}
        ></div>
        {invoice?.items?.map((itemField, index) => (
          <table key={index} style={{ width: "100%", fontSize: "24px" }}>
            <tbody>
              <tr>
                <td style={{ width: "10%", }}>{index + 1}</td>
                <td style={{ width: "65%" }}>
                  {itemField?.item?.itemName}
                  {itemField?.item?.category?.categoryId?.hsnCode && (
                    <div style={{ fontSize: "16px", color: "#666" }}>
                      SAC: {itemField?.item?.category?.categoryId?.hsnCode}
                    </div>
                  )}
                </td>
                <td
                  style={{
                    width: "15%",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  {itemField?.quantity}
                  {itemField?.item?.units?.sale?.unit?.abbreviation
                    ? ` ${itemField?.item.units.sale.unit.abbreviation}`
                    : ""}
                </td>
                <td style={{ width: "30%", textAlign: "right" }}>
                  {itemField?.quantity * itemField.item?.units?.sale?.price}
                </td>
              </tr>
            </tbody>
          </table>
        ))}
        <div
          style={{
            width: "100%",
            borderBottom: "medium dotted #333333",
            height: "5px",
          }}
        ></div>
      </div>
      <div
        style={{
          fontSize: "28px",
          paddingTop: "20px",
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <p style={{ fontSize: "28px", width: "65%" }}>Sub-Total </p>

        <p
          style={{
            fontSize: "28px",
          }}
        >
          ₹{(invoice.originalSubTotal || invoice.subTotal ).toFixed(2)}
        </p>
      </div>

      {/* Show Round-off Sub-Total Adjustment - only for new data with roundoff */}
      {Math.abs(invoice?.roundoff || 0) > 0.01 && Math.abs(invoice?.roundoffSubTotalAdj || 0) > 0.01 && (
        <div style={{ fontSize: "24px", paddingTop: "5px", width: "100%", paddingLeft: "20px", color: "#666" }}>
          <span style={{ fontSize: "24px", width: "50%" }}>Round-off Sub-Total Adj:</span>
          <span
            style={{
              fontSize: "24px",
              float: "right",
              textAlign: "right",
              width: "40%",
              color: (invoice?.roundoffSubTotalAdj || 0) >= 0 ? "#008000" : "#ff0000"
            }}
          >
            {(invoice?.roundoffSubTotalAdj || 0) >= 0 ? "+" : ""}₹{(invoice?.roundoffSubTotalAdj || 0).toFixed(2)}
          </span>
        </div>
      )}

      {invoice?.discount ? (
        <div style={{ fontSize: "28px", paddingTop: "10px", width: "100%" }}>
          <span style={{ fontSize: "28px", width: "50%" }}> Discount</span>
          <span
            style={{
              fontSize: "28px",
              float: "right",
              textAlign: "right",
              width: "40%",
            }}
          >
            ₹{invoice.discount.toFixed(2)}
          </span>
        </div>
      ) : null}

      <div style={{ fontSize: "28px", paddingTop: "10px", width: "100%" }}>
        <span style={{ fontSize: "28px", width: "50%" }}>SGST (9%)</span>
        <span
          style={{
            fontSize: "28px",
            float: "right",
            textAlign: "right",
            width: "40%",
          }}
        >
          ₹{((invoice.originalVat || invoice?.vat || 0) / 2).toFixed(3)}
        </span>
      </div>

      <div style={{ fontSize: "28px", paddingTop: "10px", width: "100%" }}>
        <span style={{ fontSize: "28px", width: "50%" }}>CGST (9%)</span>
        <span
          style={{
            fontSize: "28px",
            float: "right",
            textAlign: "right",
            width: "40%",
          }}
        >
          ₹{((invoice.originalVat || invoice?.vat || 0) / 2).toFixed(3)}
        </span>
      </div>

      {/* Show Round-off GST Adjustment - only for new data with roundoff */}
      {Math.abs(invoice?.roundoff || 0) > 0.01 && Math.abs(invoice?.roundoffGstAdj || 0) > 0.01 && (
        <div style={{ fontSize: "24px", paddingTop: "5px", width: "100%", paddingLeft: "20px", color: "#666" }}>
          <span style={{ fontSize: "24px", width: "50%" }}>Round-off GST Adj:</span>
          <span
            style={{
              fontSize: "24px",
              float: "right",
              textAlign: "right",
              width: "40%",
              color: (invoice?.roundoffGstAdj || 0) >= 0 ? "#008000" : "#ff0000"
            }}
          >
            {(invoice?.roundoffGstAdj || 0) >= 0 ? "+" : ""}₹{(invoice?.roundoffGstAdj || 0).toFixed(2)}
          </span>
        </div>
      )}

      {/* Add Roundoff Amount */}
      <div style={{ fontSize: "28px", paddingTop: "10px", width: "100%" }}>
        <span style={{ fontSize: "28px", width: "50%" }}>Round Off</span>
        <span
          style={{
            fontSize: "28px",
            float: "right",
            textAlign: "right",
            width: "40%",
            color: roundoff >= 0 ? "#008000" : "#ff0000",
          }}
        >
          {roundoff >= 0 ? "+" : ""}₹{roundoff.toFixed(2)}
        </span>
      </div>

      <div style={{ fontSize: "28px", paddingTop: "10px", width: "100%", display: (invoice.adjustedSubTotal || invoice.adjustedVat) ? "block" : "none" }}>

      {/* Divider - only show for new invoices with GST compliance data */}
      {(invoice.adjustedSubTotal || invoice.adjustedVat) && (
        <div
          style={{
            paddingTop: "20px",
            width: "100%",
            borderBottom: "medium dotted #333333",
            height: "5px",
          }}
        ></div>
      )}

      {/* Adjusted Totals Section - only show if there's meaningful roundoff and new data fields */}
      {(invoice.adjustedSubTotal || invoice.adjustedVat) && (
        <div style={{ paddingTop: "20px" }}>
          <div style={{ fontSize: "26px", fontWeight: "bold", marginBottom: "10px", textAlign: "center", color: "#333" }}>
            ADJUSTED TOTALS
          </div>
          
          {/* Adjusted Sub-Total */}
          <div style={{ fontSize: "28px", paddingTop: "10px", width: "100%" }}>
            <span style={{ fontSize: "28px", width: "50%" }}>Adj. Sub-Total</span>
            <span
              style={{
                fontSize: "28px",
                float: "right",
                textAlign: "right",
                width: "40%",
                fontWeight: "bold",
              }}
            >
              ₹{(invoice.adjustedSubTotal || invoice.originalSubTotal || invoice.subTotal || (invoice.total - (invoice.vat || 0) - (invoice.roundoff || 0))).toFixed(2)}
            </span>
          </div>

          {/* Effective GST Total */}
          <div style={{ fontSize: "28px", paddingTop: "10px", width: "100%" }}>
            <span style={{ fontSize: "28px", width: "50%" }}>Effective GST (18%)</span>
            <span
              style={{
                fontSize: "28px",
                float: "right",
                textAlign: "right",
                width: "40%",
                fontWeight: "bold",
                color: "#000"
              }}
            >
              ₹{(invoice.adjustedVat || invoice.originalVat || invoice?.vat || 0).toFixed(2)}
            </span>
          </div>

          {/* SGST/CGST Breakdown in lighter font */}
          <div style={{ fontSize: "22px", paddingTop: "5px", width: "100%", paddingLeft: "20px", color: "#666" }}>
            <span style={{ fontSize: "22px", width: "50%" }}>SGST (9%)</span>
            <span
              style={{
                fontSize: "22px",
                float: "right",
                textAlign: "right",
                width: "40%",
                color: "#666"
              }}
            >
              ₹{((invoice.adjustedVat || invoice.originalVat || invoice?.vat || 0) / 2).toFixed(3)}
            </span>
          </div>

          <div style={{ fontSize: "22px", paddingTop: "5px", width: "100%", paddingLeft: "20px", color: "#666" }}>
            <span style={{ fontSize: "22px", width: "50%" }}>CGST (9%)</span>
            <span
              style={{
                fontSize: "22px",
                float: "right",
                textAlign: "right",
                width: "40%",
                color: "#666"
              }}
            >
              ₹{((invoice.adjustedVat || invoice.originalVat || invoice?.vat || 0) / 2).toFixed(3)}
            </span>
          </div>
        </div>
      )}

      </div>

      <div
        style={{
          fontSize: "28px",
          paddingTop: "20px",
          width: "100%",
        }}
      >
        <span style={{ fontSize: "28px", width: "50%", fontWeight: "bold" }}>
          Amount Payable(₹)
        </span>
        <span
          style={{
            fontSize: "28px",
            float: "right",
            textAlign: "right",
            width: "50%",
          }}
        >
          <strong>₹{invoice.total.toFixed(2)}</strong>
        </span>
      </div>

      {invoice.paymentMode === "Cash" && (
        <>
          <div
            style={{
              fontSize: "28px",

              width: "100%",
            }}
          >
            <span style={{ fontSize: "24px", width: "50%" }}>
              Amount Paid By Guest
            </span>
            <span
              style={{
                fontSize: "28px",
                float: "right",
                textAlign: "right",
                width: "50%",
              }}
            >
              ₹{invoice.receivedAmount.toFixed(2)}
            </span>
          </div>
          <div
            style={{
              fontSize: "28px",

              width: "100%",
            }}
          >
            <span style={{ fontSize: "24px", width: "50%" }}>
              Balance Amount Return
            </span>

            <span
              style={{
                fontSize: "28px",
                float: "right",
                textAlign: "right",
                width: "50%",
              }}
            >
              ₹{invoice.change.toFixed(2)}
            </span>
          </div>
        </>
      )}
      {invoice.paymentMode === "Credit" && (
        <>
          <div
            style={{
              fontSize: "28px",

              width: "100%",
            }}
          >
            <span style={{ fontSize: "24px", width: "50%" }}>Paid</span>

            <span
              style={{
                fontSize: "28px",
                float: "right",
                textAlign: "right",
                width: "50%",
              }}
            >
              ₹{creditPayment[1].toFixed(2)}
            </span>
          </div>
          <div
            style={{
              fontSize: "28px",

              width: "100%",
            }}
          >
            <span style={{ fontSize: "24px", width: "50%" }}>Balance</span>

            <span
              style={{
                fontSize: "28px",
                float: "right",
                textAlign: "right",
                width: "50%",
              }}
            >
              ₹{(creditPayment[0] - creditPayment[1]).toFixed(2)}
            </span>
          </div>
        </>
      )}

      <div
        style={{
          paddingTop: "20px",
          width: "100%",
          borderBottom: "medium dotted #333333",
          height: "5px",
        }}
      ></div>

      {/* {invoice?.qrUrl && (
        <div style={{ textAlign: "center", marginTop: "30px" }}>
          <img src={`${process.env.REACT_APP_API}${invoice.qrUrl}`} alt="QR Code" width={128} height={128} />

        </div>
      )} */}

      {invoice?.qrTokens?.length > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "40px",
            marginTop: "30px",
          }}
        >
          {invoice.qrTokens.map((qr, index) => (
            <div key={qr.token || index} style={{ textAlign: "center" }}>
              <div style={{ fontWeight: "bold", marginBottom: "8px" }}>
                Station {qr.station}
              </div>

              <img
                src={`${process.env.REACT_APP_API}${qr.qrUrl}`}
                alt={`QR Station ${qr.station}`}
                width={128}
                height={128}
              />
            </div>
          ))}
        </div>
      )}

      <div
        style={{
          fontSize: "28px",
          paddingTop: "20px",
          width: "100%",
          textAlign: "center",
          fontWeight: "bold",
        }}
      >
        THANKS FOR VISIT
      </div>
      <div
        style={{
          fontSize: "22px",
          textAlign: "center",
          width: "100%",
          marginTop: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "15px",
        }}
      >
        <span>INSTAGRAM: toy_train_udaipur</span>
      </div>
      <div style={{ textAlign: "center", marginTop: "20px", fontSize: "18px" }}>
        <div
          style={{
            borderTop: "1px solid #333",
            paddingTop: "10px",
            marginTop: "20px",
          }}
        >
          <div style={{ textAlign: "left", marginLeft: "20px" }}>
            <p style={{ fontWeight: "bold", marginBottom: "10px" }}>NOTE:</p>
            <p>1. कम से कम 50 सवारी होने पर ही ट्रेन रवाना होगी।</p>
            <p>2. कृपया किसी भी स्थिति में ट्रेन से हाथ बाहर ना निकालें।</p>
            <p>3. यात्रा के दौरान सामान की स्वयं सुरक्षा करें।</p>
            <p>4. टिकट लेने के पश्चात् कोई रिफंड नहीं किया जायेगा।</p>
            <p>5. नाव में खड़ा होना और पानी में हाथ डालना प्रतिबंधित है।</p>
            <p>6. पानी में कोई भी वस्तु फेंकना मना है।</p>
            <p>7. नाव को नुकसान होने पर किरायेदार से वसूली की जाएगी।</p>
            <p>8. नौकायन के दौरान लाइफ जैकेट पहनना अनिवार्य है।</p>
            <p>9. नाव में खाना-पीना वर्जित है।</p>
            <p>10. सभी मामले केवल उदयपुर न्याय क्षेत्र में मान्य होंगे।</p>
            <p>
              11. प्रवेश का अधिकार प्रबंधन के पास सुरक्षित है (नगर निगम द्वारा
              स्वीकृत)।
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoicePreview;
